import React from "react";
import { Col, Row, Button, Typography } from "antd";
import { useParams } from "react-router-dom";
import Permissions from "./Permissions";
import CensusReportColumns from "./CensusReportColumns/CensusReportColumns";
import Functions from "../Common/Functions";
import ClinetReportColumns from "./ClientsColumns/ClientReportColumns";
import Filters from "./Filters";
import CensusShopCardKeys from "./CensusReportColumns/ShopCardData";
import ClientShopCardKeys from "./ClientsColumns/ClientShopCardKeys";
import SecDinination from "./SecDefinition";

const { Text } = Typography;
const { getTenantName } = Functions;
export const TenantConfig = () => {
	const { tenantName } = useParams();

	return (
		<Row gutter={[12, 12]}>
			<Col span={24}>
				<Row justify="space-between" align="middle">
					<Col flex="none">
						<Button
							type="link"
							onClick={() => {
								window.history.back();
							}}
						>
							<Text underline>Back</Text>
						</Button>
					</Col>
					<Col flex="auto" style={{ textAlign: "center" }}>
						<h1>RTM Tenant Dashboard {getTenantName(tenantName)}</h1>
					</Col>
				</Row>
			</Col>

			<Col span={24}>
				<Permissions />
			</Col>

			<Col span={12}>
				<CensusReportColumns />
			</Col>
			<Col span={12}>
				<ClinetReportColumns />
			</Col>
			<Col span={12}>
				<CensusShopCardKeys />
			</Col>
			<Col span={12}>
				<ClientShopCardKeys />
			</Col>
			<Col span={12}>
				<SecDinination />
			</Col>
			<Col span={24}>
				<Filters />
			</Col>
		</Row>
	);
};

export default TenantConfig;
